
export const TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED = 300;